import { Directive, HostListener, input, output } from '@angular/core';

// https://angularfirebase.com/lessons/drag-and-drop-file-uploads-to-firebase-storage/#file-drop-directive-ts
@Directive({
    selector: '[didoFileDrop]',
    standalone: true
})
export class FileDropBehavior {
    readonly dropDisabled = input(false);

    readonly filesDropped = output<FileList>();
    readonly filesHovered = output<boolean>();

    @HostListener('drop', ['$event'])
    onDrop($event) {
        $event.preventDefault();

        if (this.dropDisabled()) return;

        const transfer = $event.dataTransfer;
        transfer.dropEffect = 'copy';

        this.filesDropped.emit(transfer.files);
        this.filesHovered.emit(false);
    }

    @HostListener('dragover', ['$event'])
    onDragOver(event) {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';

        if (this.dropDisabled()) return;

        this.filesHovered.emit(true);
    }

    @HostListener('dragleave', ['$event'])
    onDragLeave($event) {
        if (this.dropDisabled()) return;

        this.filesHovered.emit(false);
    }
}
